import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { guardarPhotoTrazabilidad } from '../../services/Custodia/CustodiaService';
import { CamaraComponent } from './CamaraComponent';

export const SubirFotoTrazabilidad = ({ custodiaSeleccionada, onHide, toast }) => {
    const [file, setFile] = useState(null);
    const [descripcion, setDescripcion] = useState('');
    const [imagenPreview, setImagenPreview] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [coords, setCoords] = useState({ lat: null, lng: null });
    const [gpsLoading, setGpsLoading] = useState(false);
    const [gpsError, setGpsError] = useState(null);

    const obtenerUbicacion = () => {
        if (!navigator.geolocation) {
            setGpsError('Geolocalización no soportada por el navegador');
            return;
        }

        setGpsLoading(true);
        setGpsError(null);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setCoords({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
                setGpsLoading(false);
            },
            (error) => {
                let mensaje = 'No se pudo obtener la ubicación: ';
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        mensaje += 'Permiso denegado.';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        mensaje += 'Posición no disponible (pruebe en exterior).';
                        break;
                    case error.TIMEOUT:
                        mensaje += 'Tiempo agotado.';
                        break;
                    default:
                        mensaje += 'Error desconocido.';
                }
                setGpsError(mensaje);
                setGpsLoading(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 30000,
                maximumAge: 60000
            }
        );
    };

    /* ========================
       EFECTO MODAL
    ======================== */
    useEffect(() => {
        if (custodiaSeleccionada) {
            setFile(null);
            setDescripcion('');
            setImagenPreview(null);
            setCoords({ lat: null, lng: null });
            setGpsError(null);
            // setCamaraError(null);

            // iniciarCamara();
            obtenerUbicacion();
        }
        // return () => detenerCamara();
    }, [custodiaSeleccionada]);

    /* ========================
       💾 GUARDAR (SIMPLIFICADO)
    ======================== */
    const handleConfirmar = async () => {
        if (!file) {
            toast.current.show({ severity: 'warn', summary: 'Falta foto', detail: 'Debe tomar una foto' });
            return;
        }
        if (!descripcion.trim()) {
            toast.current.show({ severity: 'warn', summary: 'Falta descripción', detail: 'Escriba una descripción' });
            return;
        }

        try {
            setIsSaving(true);

            await guardarPhotoTrazabilidad(
                file,
                null, // id (nuevo registro)
                custodiaSeleccionada.id,
                descripcion,
                coords.lat && coords.lng ? coords : null // envía null si no hay coords
            );

            onHide();

            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: coords.lat ? 'Foto subida con ubicación GPS' : 'Foto subida correctamente (sin GPS)'
            });
        } catch (err) {
            console.error('Error al subir foto:', err);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo subir la foto. Intente nuevamente.'
            });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Dialog
            visible={!!custodiaSeleccionada}
            header="Subir Foto de Trazabilidad"
            modal
            style={{ width: '95vw', maxWidth: '500px' }}
            onHide={() => {
                onHide();
            }}
        >
            <div className="flex flex-column gap-4">
                {/* Camara */}
                <CamaraComponent
                    onSuccessPhoto={(photoFile) => {
                        setFile(photoFile);
                        setImagenPreview(URL.createObjectURL(photoFile));
                        obtenerUbicacion();
                    }}
                    initCamera={custodiaSeleccionada}
                />
                {/* Preview */}
                {imagenPreview && (
                    <div>
                        <p className="text-sm font-medium mb-2">Foto tomada:</p>
                        <img src={imagenPreview} alt="Preview" className="w-full border-round" style={{ maxHeight: 300, objectFit: 'contain', border: '1px solid #ccc' }} />
                    </div>
                )}

                {/* Estado GPS */}
                <div className="text-sm">
                    {gpsLoading && <small className="text-orange-600">📡 Buscando ubicación GPS... (hasta 30s)</small>}
                    {coords.lat && (
                        <small className="text-green-600">
                            📍 GPS: {coords.lat.toFixed(6)}, {coords.lng.toFixed(6)}
                        </small>
                    )}
                    {gpsError && (
                        <>
                            <small className="text-red-600 block">⚠️ {gpsError}</small>
                            <Button label="Reintentar GPS" icon="pi pi-refresh" className="p-button-outlined p-button-sm mt-2" onClick={obtenerUbicacion} disabled={gpsLoading} />
                        </>
                    )}
                </div>

                {/* Descripción */}
                <div>
                    <label className="block text-sm font-medium mb-1">Descripción</label>
                    <InputTextarea value={descripcion} onChange={(e) => setDescripcion(e.target.value)} rows={4} placeholder="Describa el estado o acción realizada..." className="w-full" />
                </div>

                {/* Guardar */}
                <Button label={isSaving ? 'Guardando...' : 'Guardar Foto'} icon="pi pi-save" className="w-full" onClick={handleConfirmar} loading={isSaving} disabled={!file || !descripcion.trim() || isSaving} />
            </div>
        </Dialog>
    );
};
